import { useState } from 'react'
import ModalVideo from 'react-modal-video'
import "../../../node_modules/react-modal-video/css/modal-video.css"

export default function VideoPopup({ video,text }) {
    const [isOpen, setOpen] = useState(false)
    return (
        <>

            <div onClick={() => setOpen(true)} className="play-btn popup-video"><i className="fas fa-play" />{text ? text : null}</div>


            <ModalVideo ratio="9:16" channel='custom' url={video} autoplay isOpen={isOpen}  onClose={() => setOpen(false)} />
        </>
    )
}